export default __webpack_public_path__ + "static/media/imagenCelularManoRobot.f36e2078.png";